import { styled } from '@mui/material/styles';
import { MenuItem } from '@sunwisesoftware/sunwise-ui';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    display: 'flex',
    padding: '16px',
    gap: 2,
    '& svg path': {
        fill: theme.palette.primary.main,
    },
    '& .MuiListItemText-primary': {
        color:
            theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.main,
        fontSize: '11px',
    },
    '&:hover': {
        '& svg': {
            transform: 'scale(1.14)',
        },
        '& svg path': {
            fill: theme.palette.primary.main,
        },
        '& .MuiListItemText-primary': {
            color:
                theme.palette.mode === 'dark'
                    ? '#fff'
                    : theme.palette.primary.main,
        },
    },
    '&.Mui-selected, &.Mui-selected:hover': {
        '& svg path': {
            fill: theme.palette.primary.main,
        },
        '& .MuiListItemText-primary': {
            color:
                theme.palette.mode === 'dark'
                    ? '#fff'
                    : theme.palette.primary.main,
        },
    },
    [theme.breakpoints.down('md')]: {
        '& .MuiListItemText-primary': {
            fontSize: '16px',
            textAlign: 'left',
        },
        '&.Mui-selected, &.Mui-selected:hover': {
            borderRight: `4px solid ${theme.palette.primary.main}`,
        },
    },
}));

export default StyledMenuItem;
